<table mat-table [dataSource]="tableDataSource" matSort multiTemplateDataRows class="mrs-table mat-elevation-z0 uw-tasks-table">
  <!-- Expand Column -->
  <ng-container matColumnDef="expand">
    <th mat-header-cell *matHeaderCellDef class="expand-column"></th>
    <td mat-cell *matCellDef="let task" class="expand-column">
      <button mat-icon-button (click)="toggleExpand(task, $event)" [attr.aria-label]="expandedTask === task ? 'Collapse notes' : 'Expand notes'">
        <mat-icon>{{ expandedTask === task ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Status Column -->
  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef class="status-column">Status</th>
    <td mat-cell *matCellDef="let task" class="status-column" >
      <mat-icon *ngIf="task.statusId === taskCompletedStatus" style="color: #1D8F0B;cursor: pointer;" (click)="toggleTaskOpenStatus(task)">check_circle</mat-icon>
      <mat-icon *ngIf="task.statusId === taskOpenStatus" style="color: #000;cursor: pointer;" (click)="toggleTaskCompletedStatus(task)">radio_button_unchecked</mat-icon>      
      <mat-icon *ngIf="task.statusId === taskRemovedStatus" style="color: rgba(106, 106, 106, 1);cursor: pointer;" (click)="toggleTaskOpenStatus(task)">remove_circle</mat-icon>
    </td>
  </ng-container>

  <!-- Name Column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="displayMode() !== 'dashboard'" class="name-column">Name</th>
    <td mat-cell *matCellDef="let task" class="name-column">
      <div [ngClass]="{'strikethrough': task.statusId === taskRemovedStatus}">{{ task.name | taskName:task.subtitle }}</div>
      <div *ngIf="task.hasAssociatedRequirement && displayMode() !== 'dashboard'" class="associated-link">
        <a href="#" class="associated-requirement">{{ task.associatedRequirementText || 'Associated Requirement' }}</a>
      </div>
    </td>
  </ng-container>

  <!-- Case Number Column (dashboard only) -->
  <ng-container matColumnDef="caseNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="displayMode() !== 'dashboard'" class="case-number-column">Case #</th>
    <td mat-cell *matCellDef="let task" class="case-number-column">{{ asDashboardTask(task).caseInfo?.caseNumberDisplay }}</td>
  </ng-container>

  <!-- Policy Number Column (dashboard only) -->
  <ng-container matColumnDef="policyNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="displayMode() !== 'dashboard'" class="policy-number-column">Policy #</th>
    <td mat-cell *matCellDef="let task" class="policy-number-column">{{ asDashboardTask(task).caseInfo?.casePolicyNumber }}</td>
  </ng-container>

  <!-- Assigned To Column -->
  <ng-container matColumnDef="assignedTo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="displayMode() !== 'dashboard'" class="assigned-to-column">Assigned To</th>
    <td mat-cell *matCellDef="let task" class="assigned-to-column">
      <single-select-dropdown-list
        [options]="displayMode() === 'dashboard' ? (assignableTaskUsersCache()[task.id] ?? []) : userOptions()"
        label=""
         [showEmptyOption]="true"
         [disabled]="readonly() || (displayMode() === 'dashboard' ? asDashboardTask(task).statusId !== taskOpenStatus : task.statusId !== taskOpenStatus)"
        emptyOptionText="Unassigned"
        (selectionChange)="onAssignedToChange(task, $event.value)"
        [ngModel]="task.assigneeId"
        (ngModelChange)="task.assigneeId = $event">
      </single-select-dropdown-list>
    </td>
  </ng-container>

  <!-- Added Date Column -->
  <ng-container matColumnDef="addedDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="displayMode() !== 'dashboard'" class="added-date-column">Added</th>
    <td mat-cell *matCellDef="let task" class="added-date-column">
      <span [matTooltip]="task.timeOfDayAdded" matTooltipPosition="after">{{ task.creationDate | date:'M/d/yyyy' }}</span>
    </td>
  </ng-container>

  <!-- Completed Date Column -->
  <ng-container matColumnDef="completedDate">
    <th mat-header-cell *matHeaderCellDef class="completed-date-column">Completed</th>
    <td mat-cell *matCellDef="let task" class="completed-date-column">
      <span [matTooltip]="task.timeOfDayCompleted" matTooltipPosition="after">{{ task.completedDate ? (task.completedDate | date:'M/d/yyyy') : '' }}</span>
    </td>
  </ng-container>

  <!-- Follow Up Date Column -->
  <ng-container matColumnDef="followUpDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="displayMode() !== 'dashboard'" class="followup-date-column">Follow Up</th>
    <td mat-cell *matCellDef="let task" class="followup-date-column">
      <mat-form-field class="followup-field w-100" subscriptSizing="dynamic">
        <input matInput [matDatepicker]="picker" placeholder="Not set"
         [disabled]="readonly() || (displayMode() === 'dashboard' ? asDashboardTask(task).statusId !== taskOpenStatus : task.statusId !== taskOpenStatus)" [(ngModel)]="task.followUpDate"
         (dateChange)="onFollowUpDateChange(task, $event.value)" [min]="minDate" [max]="maxDate">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
        <mat-error *ngIf="task.followUpDate && (task.followUpDate < minDate || task.followUpDate > maxDate)">Invalid date</mat-error>
      </mat-form-field>
    </td>
  </ng-container>

  <!-- Case Link Column (dashboard only) -->
  <ng-container matColumnDef="caseLink">
    <th mat-header-cell *matHeaderCellDef class="case-link-column"></th>
    <td mat-cell *matCellDef="let task" class="case-link-column">
      <button mat-icon-button class="open-case-icon-btn" [attr.aria-label]="'Open case'" (click)="openCase(asDashboardTask(task), $event)" matTooltip="Open case">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </td>
  </ng-container>

  <!-- Delete Column -->
  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef class="delete-column"></th>
    <td mat-cell *matCellDef="let task" class="delete-column">
        <button class="icon-button" mat-icon-button [matMenuTriggerFor]="menu" [disabled]="baseProps.readonly" (click)="$event.stopPropagation();">
            <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item
            (click)="onDeleteTask(task)" [disabled]="readonly()"  *ngIf="task.statusId === taskOpenStatus || task.statusId === taskCompletedStatus" aria-label="Delete Task">
            <span>Cancel</span>
          </button>     
          <button mat-menu-item
            (click)="toggleTaskOpenStatus(task)" [disabled]="readonly()"  *ngIf="task.statusId === taskRemovedStatus || task.statusId === taskCompletedStatus" aria-label="Delete Task">
            <span>Open</span>
          </button>                  
          <button mat-menu-item
            (click)="toggleTaskCompletedStatus(task)" [disabled]="readonly()"  *ngIf="task.statusId === taskOpenStatus" aria-label="Delete Task">
            <span>Complete</span>
          </button>    
          <button mat-menu-item
            (click)="openSubtitle(task)" [disabled]="readonly() || (displayMode() === 'dashboard' ? asDashboardTask(task).statusId !== taskOpenStatus : task.statusId !== taskOpenStatus)" >
            <span *ngIf="task.subtitle && task.subtitle != ''; else addSubtitleTemplate">Edit Subtitle</span>
            <ng-template #addSubtitleTemplate>Add Subtitle</ng-template>
          </button>
          <button mat-menu-item [disabled]="readonly() || (displayMode() === 'dashboard' ? asDashboardTask(task).statusId !== taskOpenStatus : task.statusId !== taskOpenStatus)" 
            (click)="openFollowup(task)">
            <span *ngIf="task.followUpDate && task.followUpDate != ''; else addFollowupTemplate">Edit Follow Up</span>
            <ng-template #addFollowupTemplate>Add Follow Up</ng-template>
          </button>
      </mat-menu>
    </td>
  </ng-container>

  <!-- Group Header Column (dashboard grouped view) -->
  <ng-container matColumnDef="groupHeader">
    <td mat-cell *matCellDef="let row" [attr.colspan]="displayedColumns().length" class="group-header-cell">
      <button mat-icon-button (click)="toggleCaseGroupExpand(row.caseNumberDisplay)" [attr.aria-label]="isCaseGroupExpanded(row.caseNumberDisplay) ? 'Collapse case' : 'Expand case'" class="group-expand-btn">
        <mat-icon>{{ isCaseGroupExpanded(row.caseNumberDisplay) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
      </button>
      <span class="group-header-label">Case #{{ row.caseNumberDisplay }}<span *ngIf="row.casePolicyNumber"> - Policy #{{ row.casePolicyNumber }}</span></span>
    </td>
  </ng-container>

  <!-- Expanded Row Content -->
  <ng-container matColumnDef="expandedContent">
    <td mat-cell *matCellDef="let task" [attr.colspan]="displayedColumns().length">
      <div *ngIf="task === expandedTask" [@detailExpand]="task === expandedTask ? 'expanded' : 'collapsed'" style="overflow: hidden;" class="expanded-content-wrap expanded-content">
        @if (displayMode() === 'dashboard') {
          <uw-task-notes-panel
            *ngIf="task === expandedTask"
            [taskId]="task.id"
            [caseId]="asDashboardTask(task).caseInfo?.caseId"
            [readonly]="true"
            [preloadedNotes]="asDashboardTask(task).notes">
          </uw-task-notes-panel>
        } @else {
          <uw-task-notes-panel
            *ngIf="task === expandedTask && baseProps()"
            [baseProps]="baseProps()"
            [taskId]="task.id">
          </uw-task-notes-panel>
        }
      </div>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns(); when: isTaskRow" 
  [class.expanded-row]="row === expandedTask" [class.collapsed-row]="row !== expandedTask" [class.grouped-task-row]="groupByCase()"></tr>
  <tr mat-row *matRowDef="let row; columns: ['groupHeader']; when: isGroupRow" class="group-header-row"></tr>
  <tr mat-row *matRowDef="let row; columns: ['expandedContent']" class="expanded-content-row"></tr>
  <tr class="mat-row no-data-row" *matNoDataRow>
    <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns().length">
      @if (displayMode() === 'dashboard') {
        <div class="p-4 text-center text-muted">
          <img src="./assets/images/no-data-placeholder.png" alt="" class="pb-3" />
          <h6>No Tasks Found</h6>
        </div>
      } @else {
        <div class="no-data">No tasks have been added</div>
      }
    </td>
  </tr>
</table>
